import React , { useState } from "react";
import mygif from "./footerimg/ZhtgDLNc3G.gif";

const CareerOpportunities = () => {
    
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 4000);
  };
  return (
    <div className="container">
    <section className=" container bg-white pt-5 pb-2">
      <div className="mt-5">
        <div className="row align-items-center justify-content-between">
          {/* Left Column */}
          <div className="col-xl-5 mb-4 mb-xl-0 text-dark">
            <span className="about-meta fw-semibold text-success mb-2 d-block" style={{ letterSpacing: ".05em" }}>
              CAREER OPPORTUNITIES
            </span>
            <h2 className="about-title mb-3">
              Become a part of Log e Infotech and contribute to transforming healthcare.
            </h2>
            <p className="about-description mb-4">
              At Log e Infotech, we are not merely a startup; we are a dedicated and innovative team focused on transforming healthcare. 
              We take great pride in our efforts, appreciate diverse viewpoints, and are devoted to providing outstanding solutions to our clients.
            </p>
            <div className="hero-buttons mt-3">
              <a className="btn btn-success" href="/contact/">
                View All Open Positions
              </a>
            </div>
          </div>
          {/* Right Column */}
          <div className="col-xl-6 text-center  text-xl-end">
            <div className="image-wrapper">
              <img
                alt="Business Meeting"
                className="img-fluid rounded-4"
                src={mygif}
                style={{
                      width: "100%",
                      maxWidth: "550px",
                      height: "350px",
                      objectFit: "cover"
                    }}
                   />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="services section py-5 bg-light">
  <div className="container section-title text-center mb-5">
    <h2 className="mb-3 text-dark fw-bold">
      Reasons Why Log e Infotech is the Ideal Option for Your Career
    </h2>
    <p className="mb-0 px-md-5 text-muted">
      At Log e Infotech, we provide a setting that allows your creative ideas to thrive and your professional journey to ascend to new levels.
      Become a part of our mission to revolutionize the healthcare sector through advanced solutions.
    </p>
  </div>

  <div className="container">
    <div className="row justify-content-between gy-4">
      
      {/* Card 1 */}
      <div className="col-xl-5 col-lg-6">
        <div className="service-card d-flex align-items-start bg-white rounded-4 p-4 shadow-lg h-100">
          <div className="icon flex-shrink-0 me-3 fs-1 text-success">
            <i className="bi bi-activity"></i>
          </div>
          <div>
            <h3 className="h5 fw-bold mb-2 text-dark">Work-Life Balance</h3>
            <p className="mb-0 text-secondary small">
              At Log e Infotech, we understand the importance of work-life balance. We have established a presence in multiple countries and provide a comprehensive benefit model for our team.
            </p>
          </div>
        </div>
      </div>

      {/* Card 2 */}
      <div className="col-xl-5 col-lg-6 d-flex justify-content-xl-end">
        <div className="service-card d-flex align-items-start bg-white rounded-4 p-4 shadow-lg h-100" style={{ maxWidth: '600px' }}>
          <div className="icon flex-shrink-0 me-3 fs-1 text-success">
            <i className="bi bi-diagram-3"></i>
          </div>
          <div>
            <h3 className="h5 fw-bold mb-2 text-dark">Responsible Unity</h3>
            <p className="mb-0 text-secondary small">
              Our personnel represent our most significant resource. We are committed to cultivating a cooperative atmosphere where each team member is enabled to reach their full potential.
            </p>
          </div>
        </div>
      </div>

      {/* Card 3 */}
      <div className="col-xl-5 col-lg-6">
        <div className="service-card d-flex align-items-start bg-white rounded-4 p-4 shadow-lg h-100">
          <div className="icon flex-shrink-0 me-3 fs-1 text-success">
            <i className="bi bi-easel"></i>
          </div>
          <div>
            <h3 className="h5 fw-bold mb-2 text-dark">Agile approach</h3>
            <p className="mb-0 text-secondary small">
              Log e Infotech excels in a fast-paced environment where agility and resolve are essential. We act swiftly to transform concepts into meaningful solutions.
            </p>
          </div>
        </div>
      </div>

      {/* Card 4 - d-flex justify-content-xl-end */}
      <div className="col-xl-5 col-lg-6 d-flex justify-content-xl-end">
        <div className="service-card d-flex align-items-start bg-white rounded-4 p-4 shadow-lg h-100" style={{ maxWidth: '600px' }}>
          <div className="icon flex-shrink-0 me-3 fs-1 text-success">
            <i className="bi bi-clipboard-data"></i>
          </div>
          <div>
            <h3 className="h5 fw-bold mb-2 text-dark">An Inclusive Culture</h3>
            <p className="mb-0 text-secondary small">
              We believe in a diverse and inclusive culture where everyone feels valued. We are committed to creating an environment that fosters collaboration and growth.
            </p>
          </div>
        </div>
      </div>

    </div>
  </div>

  <style>
    {`
      .service-card {
        transition: transform 0.3s ease;
        border: 1px solid rgba(0,0,0,0.05);
      }
      .service-card:hover {
        transform: translateY(-5px);
      }
    `}
  </style>
</section>
    <section className="contact section py-5" >
      <div className="container section-title mb-4 text-center">
        <h2 className="text-dark mb-3">How Log e Infotech Assists in Your Professional Growth</h2>
        <p className="text-dark mb-0">
          At Log e Infotech, we are dedicated to creating an atmosphere that enables you to flourish both personally and professionally.
          Are you interested in collaborating with Log e Infotech? Please complete the form below.
        </p>
      </div>
      <div className="container">
        <div className="row g-4 g-lg-5">
          {/* Left Column: Info Box */}
          <div className="col-lg-5">
            <div className="info-box bg-white p-4 rounded shadow-lg text-dark h-100 d-flex flex-column">
              <h3 className="mb-3 text-dark">Join with Us</h3>
              <p className="mb-4 text-dark">We encourage our team to engage in creative thinking and challenge limits. At Log e Infotech, your innovative concepts are not only welcomed but also celebrated.</p>
              <div className="info-item d-flex align-items-start mb-3">
                <div className="icon-box text-success fs-3 me-3">
                  <i className="bi bi-house"></i>
                </div>
                <div>
                  <h5 className="mb-1 text-dark">Company</h5>
                  <p className="mb-0 text-dark">Log e infotech Pvt. Ltd.</p>
                </div>
              </div>
              <div className="info-item d-flex align-items-start mb-3">
                <div className="icon-box text-success fs-3 me-3">
                  <i className="bi bi-geo-alt"></i>
                </div>
                <div>
                  <h5 className="mb-1 text-dark">Our Location</h5>
                  <p className="mb-0 text-dark">Shop no. 18, Srno- 81/1, bandal capital,</p>
                  <p className="mb-0 text-dark">Near Kothrud depo, paud road, Kothrud,</p>
                  <p className="mb-0 text-dark">India - MH - Pune - 411038</p>
                </div>
              </div>
              <div className="info-item d-flex align-items-start mb-3">
                <div className="icon-box text-success fs-3 me-3">
                  <i className="bi bi-telephone"></i>
                </div>
                <div>
                  <h5 className="mb-1 text-dark">Phone Number</h5>
                  <p className="mb-0 text-dark">+91 7773967002</p>
                  <p className="mb-0 text-dark">+91 7028287002</p>
                </div>
              </div>
              <div className="info-item d-flex align-items-start">
                <div className="icon-box text-success fs-3 me-3">
                  <i className="bi bi-envelope"></i>
                </div>
                <div>
                  <h5 className="mb-1 text-dark">Email Address</h5>
                  <p className="mb-0 text-dark">info@logesolutions.net</p>
                  <p className="mb-0 text-dark">contact@logesolutions.net</p>
                </div>
              </div>
            </div>
          </div>
          {/* Right Column: Contact Form */}
          <div className="col-lg-7">
            <div className="contact-form bg-white p-4 rounded shadow-lg text-dark h-100">
              <h3 className="mb-3 text-dark">Get In Touch</h3>
              <p className="mb-4 text-dark">
                We invite you to become a part of our network and help introduce healthcare providers to the future of healthcare management.
              </p>
              <form className="php-email-form" onSubmit={handleSubmit}>
                <div className="row gy-4">
                  <div className="col-md-6">
                    <input type="text" name="name" className="form-control" placeholder="Your Name" required />
                  </div>
                  <div className="col-md-6">
                    <input type="email" name="email" className="form-control" placeholder="Your Email" required />
                  </div>
                  <div className="col-12">
                    <input type="text" name="subject" className="form-control" placeholder="Subject" required />
                  </div>
                  <div className="col-12">
                    <textarea name="message" rows="6" className="form-control" placeholder="Message" required></textarea>
                  </div>
                  <div className="col-12 text-center">
                    {submitted && (
                      <div className="alert alert-success py-2 mb-2" role="alert">
                        Your message has been sent. Thank you!
                      </div>
                    )}
                    <button type="submit" className="btn btn-success mt-2">Apply Now</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
     </div>
  );
};

export default CareerOpportunities;
